import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

let locale = navigator.language || navigator.userLanguage;

switch (locale) {
	case 'ko':
    case 'ko-KR':
    	locale = 'ko';
        break;
	case 'en':
    case 'en-US':
    	locale = 'en';
        break;
    case 'cn':
    case 'tw':
    case 'zh':
        locale = 'cn';
    case 'vi':
    case 'vi-VN':
        locale = 'vi';
        break;
    case 'th':
    case 'th-TH':
        locale = 'th';
        break;
    default:
        locale = 'en';
        break;
}


i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: require('./locales/en.json'),
        },
        ko: {
            translation: require('./locales/ko.json'),
        },
        cn: {
            translation: require('./locales/cn.json'),
        },
        th: {
            translation: require('./locales/th.json'),
        },
        vi: {
            translation: require('./locales/vi.json'),
        },
    },
    lng: locale,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
